import React, { useState } from "react";
import { Button, Stack, Text, SheetContainer } from "@bookingcom/bui-react";
import { useDSATraceabilityController } from "./useDSATraceability.controller.js";
import { QuestionMarkCircleIcon } from "@bookingcom/bui-assets-react/streamline";
export function useCanRenderDSATraceabilityInlineModal(props) {
    const { shouldRender } = useDSATraceabilityController(props);
    return shouldRender;
}
export function DSATraceabilityInlineModal(props) {
    const { a11yClose, a11yTooltip, content, text, title } = useDSATraceabilityController(props);
    const canRender = useCanRenderDSATraceabilityInlineModal(props);
    const [active, setActive] = useState(false);
    if (!canRender)
        return null;
    return (React.createElement(Stack, { gap: 1, direction: "row", alignItems: "center", attributes: { style: { display: "inline-flex" } } },
        React.createElement(Text, { variant: "body_2" }, text),
        React.createElement(Stack.Item, null,
            React.createElement(Button, { onClick: () => setActive(true), attributes: { "aria-label": a11yTooltip }, icon: QuestionMarkCircleIcon, variant: "tertiary-neutral", mixin: { inset: 0 } }),
            React.createElement(SheetContainer, { title: title, active: active, closeAriaLabel: a11yClose, onClose: () => setActive(false), onCloseTrigger: () => setActive(false) },
                React.createElement(Stack, null, content.map((c) => (React.createElement(Text, { key: c, variant: "body_2" }, c))))))));
}
